<div class="flex flex-col">
   <div class="mat-title-medium">{{ (control().disabled ? 'approval.view_reviewers' : 'approval.add_reviewers') | translate }}</div>

   <!-- Required reviewers -->
   @if (!control().disabled || requiredReviewers().length) {
      <div class="flex flex-col">
         <div class="mat-title-small py-1">{{ 'approval.required_reviewers' | translate }}</div>
         @for (reviewer of requiredReviewers(); track reviewer.user?.id) {
            <shared-ui-target-display
               [disabled]="control().disabled"
               [menuConfig]="control().disabled ? [] : removeMenuConfig"
               [target]="reviewer.user"
               avatarType="initials"
            ></shared-ui-target-display>
         } @empty {
            @if (clientContacts.isLoading()) {
               <shared-ui-skeleton-loader
                  [skeletonConfig]="{ appearance: { rows: 1, divider: false } }"
                  class="my-1"
               ></shared-ui-skeleton-loader>
            }
         }
         @if (!control().disabled && availableContacts().length) {
            <div
               #selectContactMenu="matMenuTrigger"
               [matMenuTriggerData]="{ role: 'required' }"
               [matMenuTriggerFor]="contactMenu"
            >
               <shared-ui-target-display
                  (rowClick)="selectContactMenu.openMenu()"
                  [disabled]="control().disabled"
                  [errorMessage]="requiredReviewError()"
                  [required]="!requiredReviewers().length"
                  emptyText="approval.choose_contact"
               ></shared-ui-target-display>
            </div>
         }
      </div>
   }

   <!-- Optional reviewers -->
   @if (!control().disabled || optionalReviewers().length) {
      <div class="flex flex-col">
         <div class="mat-title-small py-1">{{ 'approval.optional_reviewers' | translate }}</div>
         @for (reviewer of optionalReviewers(); track reviewer.user?.id) {
            <shared-ui-target-display
               [disabled]="control().disabled"
               [menuConfig]="control().disabled ? [] : removeMenuConfig"
               [target]="reviewer.user"
               avatarType="initials"
            ></shared-ui-target-display>
         } @empty {
            @if (clientContacts.isLoading()) {
               <shared-ui-skeleton-loader
                  [skeletonConfig]="{ appearance: { rows: 1, divider: false } }"
                  class="my-1"
               ></shared-ui-skeleton-loader>
            }
         }
         @if (!control().disabled && availableContacts().length) {
            <div
               #selectContactMenu="matMenuTrigger"
               [matMenuTriggerData]="{ role: 'optional' }"
               [matMenuTriggerFor]="contactMenu"
            >
               <shared-ui-target-display
                  (rowClick)="selectContactMenu.openMenu()"
                  [disabled]="control().disabled"
                  emptyText="approval.choose_contact"
               ></shared-ui-target-display>
            </div>
         }
      </div>
   }

   <mat-menu #contactMenu="matMenu">
      <ng-template
         let-role="role"
         matMenuContent
      >
         @for (contact of availableContacts(); track contact.id) {
            <button
               (click)="addContact(contact, role)"
               mat-menu-item
            >
               {{ contact | fullName }}
            </button>
         } @empty {
            <button
               disabled
               mat-menu-item
            >
               {{ 'approval.no_contacts_available' | translate }}
            </button>
         }
      </ng-template>
   </mat-menu>
</div>
